"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.saveExemptUsers = exports.updateSamlRequirement = exports.saveSamlSettings = exports.getSsoEnabled = exports.fetchSamlSettings = exports.deleteSamlSettings = exports.confirmSamlSettingsEpic = void 0;

var _reduxObservable = require("redux-observable");

var _catchError = require("rxjs/operators/catchError");

var _concat = require("rxjs/observable/concat");

var _filter = require("rxjs/operators/filter");

var _fromPromise = require("rxjs/observable/fromPromise");

var _map = require("rxjs/operators/map");

var _mergeMap = require("rxjs/operators/mergeMap");

var _of = require("rxjs/observable/of");

var _startWith = require("rxjs/operators/startWith");

var _RequestStatusTypeFilters = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypeFilters"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _API = _interopRequireDefault(require("./API"));

var _actions = require("./actions");

var _constants = require("./constants");

var _requestSelectors = require("./requestSelectors");

var _selectors = require("./selectors");

var _epics = require("../SingleSignOnLogin/epics");

var confirmSamlSettingsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.confirmSaml,
  initiatingActionType: _actions.SingleSignonApiActionTypes.CONFIRM_SAML_SETTINGS,
  requestStatusSelector: _requestSelectors.getConfirmSamlSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.ConfirmSamlSettings
}));
exports.confirmSamlSettingsEpic = confirmSamlSettingsEpic;
var deleteSamlSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteSamlSettings,
  initiatingActionType: _actions.SingleSignonApiActionTypes.DELETE_SAML_SETTINGS,
  requestStatusSelector: _requestSelectors.getDeleteSamlSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.DeleteSamlSettings
}));
exports.deleteSamlSettings = deleteSamlSettings;
var fetchSamlSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSamlSettings,
  initiatingActionType: _actions.SingleSignonApiActionTypes.FETCH_SAML_SETTINGS,
  requestStatusSelector: _requestSelectors.getFetchSamlSettingsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_ONCE,
  requestActions: _actions.FetchSamlSettings,
  sc404isSuccess: true
}));
exports.fetchSamlSettings = fetchSamlSettings;
var getSsoEnabled = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSsoEnabled,
  initiatingActionType: _actions.SingleSignonApiActionTypes.GET_SSO_ENABLED,
  requestStatusSelector: _requestSelectors.getSsoEnabledRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_ONCE,
  requestActions: _actions.GetSsoEnabled
}));
exports.getSsoEnabled = getSsoEnabled;

var saveSamlSettings = function saveSamlSettings($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.SingleSignonApiActionTypes.SAVE_SAML_SETTINGS).pipe((0, _filter.filter)(function () {
    var status = (0, _requestSelectors.getSaveSamlSettingsRequestStatus)(getState());
    return _RequestStatusTypeFilters.default.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(function () {
    var staged = (0, _selectors.getStagedSamlIdp)(getState()).toJS();
    return (0, _fromPromise.fromPromise)(_API.default.updateSamlSettings(staged)).pipe((0, _mergeMap.mergeMap)(function (response) {
      var success = (0, _of.of)(_actions.SaveSamlSettings.success(response, staged));

      if (response[_constants.PENDING_SAML_IDP] === null) {
        return (0, _concat.concat)(success, (0, _of.of)(_actions.ConfirmSamlSettings.success(response, staged)));
      }

      return (0, _concat.concat)(success, (0, _epics.performSamlConfirmation)(getState));
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.SaveSamlSettings.failure(error, staged));
    }), (0, _startWith.startWith)(_actions.SaveSamlSettings.request(staged)));
  }));
};

exports.saveSamlSettings = saveSamlSettings;
var updateSamlRequirement = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateSamlRequirement,
  initiatingActionType: _actions.SingleSignonApiActionTypes.UPDATE_SAML_REQUIREMENT,
  requestStatusSelector: _requestSelectors.getUpdateSamlRequirementRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.UpdateSamlRequirement
}));
exports.updateSamlRequirement = updateSamlRequirement;

var saveExemptUsers = function saveExemptUsers($action, _ref2) {
  var getState = _ref2.getState;
  return $action.ofType(_actions.SingleSignonApiActionTypes.SAVE_EXEMPT_USERS).pipe((0, _filter.filter)(function () {
    var status = (0, _requestSelectors.getSaveExemptUsersRequestStatus)(getState());
    return _RequestStatusTypeFilters.default.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(function () {
    var staged = (0, _selectors.getStagedExemptUserIds)(getState()).toJS();
    return (0, _fromPromise.fromPromise)(_API.default.setExemptUsers(staged)).pipe((0, _map.map)(function (response) {
      return _actions.SaveExemptUsers.success(response, staged);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.SaveExemptUsers.failure(error, staged));
    }), (0, _startWith.startWith)(_actions.SaveExemptUsers.request(staged)));
  }));
};

exports.saveExemptUsers = saveExemptUsers;

var _default = (0, _reduxObservable.combineEpics)(confirmSamlSettingsEpic, deleteSamlSettings, fetchSamlSettings, getSsoEnabled, saveSamlSettings, updateSamlRequirement, saveExemptUsers);

exports.default = _default;